import React, { useState } from "react";
import "./CustomList.css";

const CustomList = ({ items }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleItem = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="custom-list">
      {items.map((item, index) => (
        <div key={index} className="custom-list-item">
          <div
            className="custom-list-title"
            onClick={() => toggleItem(index)}
          >
            {item.title}
          </div>
          {openIndex === index && (
            <div className="custom-list-content">{item.text}</div>
          )}
        </div>
      ))}
    </div>
  );
};

export default CustomList;
